import React, { useEffect, useState } from 'react';
import { estoqueApi } from '../../../api/estoque';
import { COLORS } from '../../../theme';

export default function HistoricoComprasTab({ fornecedorId }) {
  const [movimentacoes, setMovimentacoes] = useState(null);

  useEffect(() => {
    if (!fornecedorId) return;
    estoqueApi.movimentacoes({ fornecedor_id: fornecedorId, tipo: 'entrada', limite: 100 }).then(setMovimentacoes).catch(() => setMovimentacoes([]));
  }, [fornecedorId]);

  if (!fornecedorId) return <p style={{ color: COLORS.textMid, fontSize: 14 }}>Salve o fornecedor antes de ver o histórico de compras.</p>;
  if (movimentacoes === null) return <p>Carregando...</p>;
  if (movimentacoes.length === 0) return <p style={{ color: COLORS.textMid, fontSize: 14 }}>Nenhuma entrada de estoque registrada com este fornecedor ainda.</p>;

  const total = movimentacoes.reduce((soma, m) => soma + Number(m.quantidade) * Number(m.custo_unitario || 0), 0);

  return (
    <div>
      <p style={{ fontSize: 13, color: COLORS.textMid, marginTop: 0 }}>
        Baseado nas entradas de estoque registradas com este fornecedor. Total: <strong style={{ color: COLORS.text }}>R$ {total.toFixed(2)}</strong>
      </p>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
        <thead>
          <tr style={{ textAlign: 'left', background: COLORS.bg }}>
            <th style={{ padding: 8 }}>Data</th>
            <th style={{ padding: 8 }}>Produto</th>
            <th style={{ padding: 8 }}>Quantidade</th>
            <th style={{ padding: 8 }}>Custo Unit.</th>
            <th style={{ padding: 8 }}>Total</th>
            <th style={{ padding: 8 }}>Documento</th>
          </tr>
        </thead>
        <tbody>
          {movimentacoes.map(m => (
            <tr key={m.id} style={{ borderTop: `1px solid ${COLORS.border}` }}>
              <td style={{ padding: 8 }}>{m.data_movimentacao}</td>
              <td style={{ padding: 8 }}>{m.produto_codigo} - {m.produto_descricao}</td>
              <td style={{ padding: 8 }}>{m.quantidade}</td>
              <td style={{ padding: 8 }}>{m.custo_unitario ? `R$ ${Number(m.custo_unitario).toFixed(2)}` : '-'}</td>
              <td style={{ padding: 8 }}>{m.custo_unitario ? `R$ ${(Number(m.quantidade) * Number(m.custo_unitario)).toFixed(2)}` : '-'}</td>
              <td style={{ padding: 8 }}>{m.documento_numero || '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
